import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
import HtmlEditor, {
  TableContextMenu,
  TableResizing,
  Toolbar,
  Item,
} from "devextreme-react/html-editor";
import {
  GetApp as IconExport,
  LocationCityOutlined,
} from "@mui/icons-material";
import {
  Close as IconClose,
  Edit as IconEdit,
  LocationOn as LocationIcon,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";

import Btn from "components/Custom/Btn";
import AutoComplete from "components/Custom/AutoComplete";
import ConfirmDialog from "components/Custom/ConfirmDialog";
import RichTxtBox from "components/Custom/RichTxtBox";
import SkeletonBox from "components/Custom/SkeletonBox";
import TxtBox from "components/Custom/TxtBox";

import { NOTIFY, DEFAULTS, FORMATS, CONFIG, API_CONFIG } from "common/config";
import { COLORS } from "common/colors";
import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  TITLES,
  CONFIRMS,
} from "common/labels";
import { ApiIndents } from "apihandlers//indent";
import { ApiMasters } from "apihandlers//masters/masters";
import { COMMON_JS } from "common/scripts";
import { Row } from "react-data-grid";
import ExcelGrid from "components/Custom/ExcelGrid";
import UiDialog from "components/Custom/UiDialog";

const ApiIndentHandler = new ApiIndents();
const ApiMastersHandler = new ApiMasters();

const thumbnailImg = require("assets/images/pdf.png");

const DeliveryComments2 = (props: any) => {
  const tripsRef: any = useRef();

  const [loading, setLoading] = useState(true);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [deliveryFiles, setDeliveryFiles] = useState<any>({});
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [trips, setTrips] = useState<any>(null);
  const [history, setHistory] = useState<any>(null);
  const [apiArgs, setApiArgs] = useState<any>({});
  const [markup, setMarkup] = useState("<br/>");
  const [historyId, setHistoryId] = useState("");
  const [htmlLoading, setHtmlLoading] = useState(false);
  const [points, setPoints] = useState<any>([]);

  const jRef = useRef(null);

  const options = {
    data: [[]],
    minDimensions: [10, 10],
  };

  const COLUMNS = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
      frozen: true,
    },
    {
      key: "from",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FROM,
      width: "10%",
      frozen: true,
    },
    {
      key: "tripNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TRIP_NO,
      width: "10%",
      frozen: true,
    },
    {
      key: "tripDate",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TRIP_DATE,
      width: "10%",
    },
    {
      key: "vehicleNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_NO,
      width: "10%",
    },
    {
      key: "driverName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DRIVER_NAME,
      width: "10%",
    },
    {
      key: "driverNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DRIVER_MOBILE_NO,
      width: "10%",
    },
    {
      key: "dealerName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DEALER_NAME,
      width: "10%",
    },
    {
      key: "deliveryComments",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.DELIVERY_COMMENTS,
      width: "20%",
    },
    {
      key: "inTime",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.IN_TIME,
      width: "10%",
    },
    {
      key: "outTime",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.OUT_TIME,
      width: "10%",
    },
    {
      key: "weight",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.TOTAL_DURATION,
      width: "5%",
    },
    {
      key: "pod",
      type: "html",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.POD,
      width: "5%",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
  };

  useEffect(() => {
    if (loading) {
      getTrips();
    }
  }, []);

  const getTrips = async () => {
    const args = { activeStatus: "true" };
    const res: any = await ApiIndentHandler.getTrips(args);
    const { status, response } = res;
    if (status === 200) {
      let list = response.records.map((r: any) => {
        return {
          id: r.id,
          label: r.indentNo,
        };
      });
      setTrips(list);
      setRows(list);
      setLoading(false);
    }
  };

  const onConfirmApprove = (id) => {
    const html = document.querySelector(
      "#gridEditor-" + id + " .ql-editor"
    ).innerHTML;
    const indentId = tripsRef.current.selectedValue.id;
    const args = {
      id: -1,
      loadingPointArea: id,
      indentId,
      deliveryComments: html,
      files: deliveryFiles.length > 0 ? deliveryFiles[0].id : -1,
    };
    setLoading(true);
    ApiIndentHandler.manageLoadingPtComment(args).then((res) => {
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, "Saved Successfully..!");
        setLoading(false);
        getRows();
      } else {
        setLoading(false);
        COMMON_JS.showNotify(props, NOTIFY.ERROR, "Not Saved Successfully..!");
      }
    });
  };

  // todo: getLoadingPtComments  for delivery comments
  const getRows = async () => {
    const indentId = tripsRef.current.selectedValue.id;
    if (!indentId) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.TRIP_EMPTY);
      return;
    }
    const args = {
      indentId,
    };
    // setRows(null);
    const res = await ApiIndentHandler.getLoadingPtComments(args);
    const response: any = res.response;
    const { status } = res;
    if (status === 200) {
      let list = response.records;
      for (let i = 0; i < response.records.length; i++) {
        list[i]["slNo"] = i + 1;
        // setMarkup(list[0].deliveryComments);
        // setHistoryId(response[0].id);
      }
      // setHistory(response);
      setRows(list);
      setLoading(false);
    }
  };

  // const getData = () => {
  //   const indentId = tripsRef.current.selectedValue.id;
  //   if (!indentId) {
  //     COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.TRIP_EMPTY);
  //     return;
  //   }
  //   const args = {
  //     indentId,
  //   };
  //   setLoading(true);
  //   ApiIndentHandler.getLoadingPtComments(args).then((res: any) => {
  //     if (res.status === 200) {
  //       let recs = res.response;
  //       if (recs.length > 0) {
  //         setMarkup(recs[0].html_text);
  //         setHistoryId(recs[0].id);

  //       }
  //       setHistory(recs);
  //       setLoading(false);
  //     }
  //   });
  // };

  const onRemovePod = async (fileId) => {
    setDeliveryFiles(null);
    try {
      const args = {
        fileId,
      };
      const res = await ApiIndentHandler.removePodAttachment(args);
      const response: any = res.response;
      if (res.status === 200) {
        onChangeTrip();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, res.error);
      }
    } catch (error) {}
  };

  const onUploadFile = (e: any, loadingId: number, indentId) => {
    console.log("onUploadFile: ", e, loadingId);
    const file: any = e.target.files[0];
    if (file.size / 1024 / 1024 > CONFIG.MAX_FILE_SIZE) {
      COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.FILE_SIZE_EXCEEDED);
      return;
    }
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      let base64: any = reader.result;
      setDeliveryFiles(null);
      uploadFile(file, base64, loadingId, indentId).then((res) => {
        if (res) {
          let files = deliveryFiles;
          files[loadingId].push(res);
          setDeliveryFiles({ ...deliveryFiles, files });
        } else {
          setDeliveryFiles(deliveryFiles);
          e.target.value = "";
        }
      });
    };
    reader.onerror = (error) => {
      console.log("uploadFile: Error:", error);
    };
  };

  const uploadFile = async (
    file: any,
    base64 = "",
    loadingPointId,
    indentId
  ) => {
    const args = {
      recordRefId: indentId,
      loadingPointId,
      file: {
        name: file.name,
        data: base64.replace("data:", "").replace(/^.+,/, ""),
        type: file.type,
        mimeType: file.name.split(".")[1],
        size: file.size,
      },
      category: "pod",
    };
    let fileInfo = null;
    try {
      const res = await ApiIndentHandler.fileUpload(args);
      console.log("uploadFile: ", args, res);
      const response: any = res.response;
      if (res.status === 200) {
        fileInfo = response;
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, res.error);
      }
    } catch (error) {}
    return fileInfo;
  };

  const exportData = () => {
    let projectName = "";
    if (tripsRef.current) {
      projectName = tripsRef.current.selectedValue.label;
    }
    const html = document.querySelector(".ql-editor").innerHTML;
    const title = LABELS.RISKS_REGISTER + " - " + projectName;
    let header = "<html>";
    header +=
      "<head><title>" +
      title +
      "</title><style>@page{margin-top:10px;size: A3 landscape}@media print {td,th{border:1px solid #000;border-bottom: none;} tr:last-child td {border-bottom: 1px solid #000;} td:not(:last-child),th:not(:last-child){border-right: none;}}</style></head>";
    let body =
      "<body style='border:1px solid #ccc;'><div style='width:95%;margin:auto;display:flex;flex-direction:column;justify-content:center;'><h2 style='text-align: center;margin-top:20px;margin-bottom:10px;'>" +
      title +
      "</h2>";
    let htmlText = header + body + html + "</div></body></html>";
    console.log(htmlText);
    const printWin = window.open("", "", "toolbar=0,scrollbars=0,status=0");
    printWin.document.write(htmlText);
    printWin.document.close();
    printWin.focus();
    printWin.print();
    printWin.close();
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    // const indentId = tripsRef.current.selectedValue.id;
    // if (!indentId) {
    //   COMMON_JS.showNotify(props, NOTIFY.WARNING, WARNINGS.TRIP_EMPTY);
    //   return;
    // }
    setSelectedRow({});
    setManageDialog(true);
  };

  const onChangeTrip = () => {
    const indentId = tripsRef.current.selectedValue.id;
    const args = {
      indentId,
    };
    setPoints(null);
    ApiIndentHandler.getLoadingPtComments(args).then((res: any) => {
      if (res.status === 200) {
        const list = res.response.records;
        let filesObj = {};
        for (let i = 0; i < list.length; i++) {
          filesObj[list[i].id] = list[i].files || [];
        }
        setPoints(list);
        setDeliveryFiles(filesObj);
      }
    });
  };

  // const tripsRef: any = useRef();
  const htmlEditor = useRef(null);

  console.log("points:", points, deliveryFiles);

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.TRANSACTIONS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{LABELS.DELIVERY_COMMENTS}</li>
        </ul>
        <h4>{LABELS.DELIVERY_COMMENTS}</h4>
      </div>

      <div className="formGroup" style={{ width: "100%" }}>
        <label>{LABELS.SELECT_TRIP}</label>
        <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
          <div style={{ width: "30%", marginRight: 10 }}>
            <AutoComplete
              id={"trips"}
              list={trips}
              childRef={tripsRef}
              defaultValue={
                selectedRow.indentId ? selectedRow.indentGroup : null
              }
              onChange={onChangeTrip}
            />
          </div>
        </div>
      </div>

      {points && (
        <div className="grid flexColumn" style={{ marginBottom: 30 }}>
          {points.map((point, i) => {
            return (
              <div
                className="flexColumn"
                style={{
                  boxShadow: "1px 2px 5px #ccc",
                  border: "1px solid #ccc",
                  padding: "0px 15px",
                  borderRadius: 5,
                  width: "95%",
                  marginBottom: 20,
                }}
              >
                <div
                  className="flexRow"
                  style={{ alignItems: "center", margin: "5px 0px" }}
                >
                  <LocationIcon
                    style={{
                      marginRight: 10,
                      color: COLORS.PRIMARY,
                      fontSize: "1rem",
                    }}
                  />
                  <h4 className="bold" style={{ margin: 0 }}>
                    {point.areaName}
                  </h4>
                </div>
                <div className="formGroup">
                  <label>{LABELS.COMMENTS}</label>
                  <RichTxtBox
                    id={"gridEditor-" + point.id}
                    defaultValue={point.deliveryComments}
                  />
                </div>
                <div className="formGroup">
                  <label>
                    {LABELS.PHOTO_UPLOAD}
                    <small>
                      {" ( Max File Size: " + CONFIG.MAX_FILE_SIZE + " MB )"}
                    </small>
                  </label>
                  <TxtBox
                    type={"file"}
                    id="uploadFile"
                    className="uploadFile"
                    accept="image/*,.pdf"
                    onChange={(e) => onUploadFile(e, point.id, point.indentId)}
                  />
                  <div
                    className="formGroup"
                    style={{
                      width: "100%",
                      display: "flex",
                      flexDirection: "row",
                      flexWrap: "wrap",
                    }}
                  >
                    {!deliveryFiles ? (
                      <div className="thumbnailBox width10">
                        <SkeletonBox height={300} />
                      </div>
                    ) : (
                      deliveryFiles[point.id].map((u, i) => {
                        const filePath = API_CONFIG.STATIC_URL + u.path;
                        return (
                          <div className="thumbnailBox width10">
                            <IconButton
                              className="thumbnailBoxIcon"
                              onClick={() => onRemovePod(u.fileId)}
                            >
                              <IconClose />
                            </IconButton>
                            <img
                              onClick={() => window.open(filePath, "_blank")}
                              src={
                                u.mimeType === "pdf" ? thumbnailImg : filePath
                              }
                              className="responsive cursor"
                            />
                          </div>
                        );
                      })
                    )}
                  </div>
                </div>
                <div className="formGroup">
                  <Btn
                    text={LABELS.SAVE}
                    onClick={() => onConfirmApprove(point.id)}
                    loading={loading}
                  />
                </div>
              </div>
            );
          })}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(DeliveryComments2);
